import { getSeguro, getSeguroPdf, postSeguro, deleteSeguro } from "../../shared/helper/requests";
import { MSG_ERRO_IMPRESSAO } from "../../shared/constantes/mensagens";
import { criarDownloadPdf } from "../../shared/helper/impressao";
import { showError } from "../../shared/helper/messages";

export const init = () => ({
  type: 'CARTEIRA_INIT'
})

export const setFoto = foto => ({
  type: 'CARTEIRA_SET_FOTO',
  payload: foto
});

export const setBeneficiosCarteira = (beneficios, validade) => ({
  type: 'CARTEIRA_SET_BENEFICIOS_CARTEIRA',
  payload: { beneficios, validade }
});

export const setCheckCient = value => ({
  type: 'CARTEIRA_SET_CHECK_CIENTE',
  payload: value
})

export const setShow = value => ({
  type: 'CARTEIRA_SET_SHOW',
  payload: value
});

export const iniciarBuscarFoto = () => ({
  type: 'CARTEIRA_INIT_BUSCA_FOTO'
});

export const buscarFoto = () => {
  return function (dispatch) {
    dispatch(iniciarBuscarFoto())
    return getSeguro(dispatch, 'carteiraServices/download',
      receberFotoSucesso,
      receberFotoErro);
  }
}

export const receberFotoSucesso = dados => ({
  type: 'CARTEIRA_BUSCA_FOTO_SUCESSO',
  payload: dados
});

export const receberFotoErro = error => {  
  console.error(error);
  showError('Não foi possível salvar a foto, tente novamente mais tarde.');
  return ({ type: 'CARTEIRA_BUSCA_FOTO_ERROR' });
}

export const iniciarIncluirFoto = () => ({
  type: 'CARTEIRA_INIT_INCLUIR_FOTO'
});

export const incluirFoto = foto => {
  return function (dispatch) {
    dispatch(iniciarIncluirFoto())
    return postSeguro(dispatch, 'carteiraServices/upload',
      { dadosBase64: `${foto.split(',')[1]}` },
      incluirFotoSucesso,
      incluirFotoErro);
  }
}

export const incluirFotoSucesso = dados => ({
  type: 'CARTEIRA_INCLUIR_FOTO_SUCESSO',
  payload: dados
});

export const incluirFotoErro = error => {
  console.error(error);
  showError('Não foi possível incluir a foto, verifique o tipo e tamanho da imagem e tente novamente');
  return ({ type: 'CARTEIRA_INCLUIR_FOTO_ERROR' });
}

export const imprimirCarteira = code => dispatch => {    
  dispatch({ type: 'CARTEIRA_IMPRESSAO_SOLICITADA' });
  return getSeguroPdf(dispatch, `carteiraServices/carteiraBeneficiario/${code}`,
    receberImpressao, 
    receberErroPdf);
}

export const receberImpressao = (data) => {
  let msg = criarDownloadPdf(data, `carteira_beneficiario.pdf`);
  if (msg) showError(msg);
  return { type: "CARTEIRA_PDF_RECEBIDO" };
};

const receberErroPdf = error => {
  showError(MSG_ERRO_IMPRESSAO);
  return { type: 'CARTEIRA_IMPRESSAO_ERRO' }
}

export const iniciarDeleteFoto = () => ({
  type: 'CARTEIRA_INIT_DELETE_FOTO'
});

export const deleteFoto = () => {
  return function (dispatch) {
    dispatch(iniciarDeleteFoto())
    return deleteSeguro(dispatch, 'carteiraServices/delete',
      deletarFotoSucesso,
      deleteFotoErro);
  }
}

export const deletarFotoSucesso = dados => ({
  type: 'CARTEIRA_DELETE_FOTO_SUCESSO',
  payload: dados
});

export const  deleteFotoErro = error => {  
  console.error(error);
  showError('Não foi possível deletar a foto, tente novamente mais tarde.');
  return ({ type: 'CARTEIRA_DELETE_FOTO_ERROR' });
}
